import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-17',
  templateUrl: './17.component.html',
  styleUrls: ['./17.component.scss'],
})
export class VbList17Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
